function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import PropTypes from 'prop-types';
import React from 'react';
import useFullStory from '../hooks/useFullStory';
import { LINK_FULLSTORY_USER_ID } from '../serverDispatchActionTypes';
import serverDispatch from '../services/serverDispatch';
import { IdentityContext } from './IdentityProvider';
var FullStoryIdentifier = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children;
  var FullStory = useFullStory();
  var _React$useContext = React.useContext(IdentityContext),
    uid = _React$useContext.uid,
    identity = _React$useContext.identity;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    identified = _React$useState2[0],
    setIdentified = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    linkAttempted = _React$useState4[0],
    setLinkAttempted = _React$useState4[1];
  var displayName = identity ? identity.displayName : null;
  var email = identity ? identity.email : null;
  var fullStoryUserId = identity ? identity.fullStoryUserId : null;
  React.useEffect(function () {
    if (uid && displayName && email && !identified) {
      FullStory.identify(uid);
      setIdentified(true);
    }
    if (uid && displayName && email && identified) {
      FullStory.setUserVars({
        displayName: displayName,
        email: email,
        properties: {
          app: 'paperstac'
        }
      });
    }
    if (!uid && identified) {
      FullStory.anonymize();
      setIdentified(false);
    }
  }, [uid, displayName, email, identified]);
  React.useEffect(function () {
    if (uid && !fullStoryUserId && !linkAttempted) {
      setLinkAttempted(true);
      serverDispatch({
        action: LINK_FULLSTORY_USER_ID
      })["catch"](function (e) {
        return console.log(e);
      });
    }
  }, [uid, fullStoryUserId, linkAttempted]);
  return children;
});
FullStoryIdentifier.propTypes = {
  children: PropTypes.element.isRequired
};
export default FullStoryIdentifier;